export function formatPrice(price: number, showCurrency: boolean = true) {
    const numberFormat = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0
    });
    let formattedPrice = numberFormat.format(price);
    if (!showCurrency) {
        formattedPrice = formattedPrice.replace('€', '').trim(); // Remove the euro symbol and trim any extra spaces
    } else {
        formattedPrice = formattedPrice.replace(' €', '€'); // Adjust spacing around the euro symbol
    }
    return formattedPrice;
}
